import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// #78: autoplay is an ENUM (never | whenScrolledIntoView), not a boolean —
// "whenScrolledIntoView" hands playback to the coordinator. Legacy Yes/No resolve.
export const AUTOPLAY_NEVER = "never";
export const AUTOPLAY_WHEN_SCROLLED_INTO_VIEW = "whenScrolledIntoView";

export default class Autoplay extends BaseOption {
  static userInterfaceComponent = {
    label: "Autoplay",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          icon: "mdi:eye-outline",
          tooltip: "Play when scrolled into view",
          value: AUTOPLAY_WHEN_SCROLLED_INTO_VIEW,
        },
        {
          icon: "mdi:close",
          tooltip: "Never autoplay",
          value: AUTOPLAY_NEVER,
        },
      ],
    },
  };

  static defaultValue = AUTOPLAY_NEVER;

  static convertConfigValueToCompiledValue(configValue) {
    // Legacy boolean-ish values (Yes / true) map to the scroll-into-view mode.
    if (configValue === AUTOPLAY_WHEN_SCROLLED_INTO_VIEW || configValue === "Yes" || configValue === true) {
      return AUTOPLAY_WHEN_SCROLLED_INTO_VIEW;
    }
    return AUTOPLAY_NEVER;
  }
}
